export const normalizeStatus = (value) => {
  if (typeof value === 'string') return value.trim().toLowerCase();
  if (typeof value === 'number' || typeof value === 'boolean') return String(value).toLowerCase();

  if (value && typeof value === 'object') {
    const nestedStatus = value.status ?? value.label ?? value.value ?? '';
    return String(nestedStatus).trim().toLowerCase();
  }

  return '';
};

export const getStatusLabelValue = (value, fallback = '-') => {
  if (value === null || value === undefined) return fallback;
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);

  if (typeof value === 'object') {
    return value.label || value.status || value.value || fallback;
  }

  return fallback;
};
